import { BASE_URL } from "./api";
import axios from "axios";

export async function getMostRecentInvoicesRecordedLog(token) {
    return axios({
        method: "get",
        url: `${BASE_URL}/invoices_recorded_logs/get_most_recent_invoices_recorded_log/`,
        headers: {
            'Authorization': `Token ${token}`
        }
    })
    .then(response => response.data)
    .catch(error => console.error(error))
}

export async function createInvoicesRecordedLog(token, data) {
    return axios({
        method: "post",
        url: `${BASE_URL}/invoices_recorded_logs/`,
        headers: {
            'Authorization': `Token ${token}`
        },
        data: data
    })
    .then(response => response)
    .catch(error => error)
}


